import React, { Component } from 'react';
import i18n from 'i18n-react';
import { spring, StaggeredMotion } from 'react-motion';

import { baseAppId, storageKeys } from 'settings';
import {
  APIHandler,
  ContentHeader,
  DataHandler,
  StorageHandler,
  SubAppButton,
  TrainingCard,
} from 'C4';
import clsx from 'clsx';

const trackShare = (chapterNumber) => {
  const value = `chapter-${chapterNumber}`;
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj.response);
      APIHandler.trackEvent(appId, email, 'retention', 'chapter', value).then(
        () => {}
      );
    });
  });
};

export default class RetainGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chapters: [],
      chapters_progress: [],
      lockedChapters: [],
      subApps: [],
    };

    this.loadChapters = this.loadChapters.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
  }

  componentWillMount() {
    this.mounted = true;
    this.getProgress();
    this.setSubApps(baseAppId);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getProgress() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res.response;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.getUserProgress(appId, email).then((userProgress) => {
            this.calculateProgress(userProgress);
          });
        });
      }
    });
  }

  getSubAppProgress(appIds) {
    return StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res.response;
        if (this.mounted && appIds.apps.length > 0) {
          return APIHandler.getUserProgress(appIds.apps, email).then(
            (userProgress) => {
              const progress = Object.values(userProgress.data).map((app) => {
                const [chapter] = app.chapters;
                const { name } = app;
                return {
                  chapter,
                  name,
                };
              });
              return progress;
            }
          );
        }
      }
      return null;
    });
  }

  setSubApps(appId) {
    return APIHandler.getSubApps(appId).then((ids) => {
      this.getSubAppProgress(ids).then((progress) => {
        if (progress) {
          const subAppPromises = ids.apps.map((id, i) => {
            const pageId =
              progress[i].chapter.last_page < progress[i].chapter.total_pages
                ? progress[i].chapter.last_page
                : 0;
            const key = i;
            return APIHandler.getChapters(id).then((chapter) => {
              const [newApp] = chapter.app;
              return (
                <SubAppButton
                  key={`${key}_${newApp.chapterImage}`}
                  appId={id}
                  progress={progress[i].chapter}
                  name={progress[i].name}
                  pageId={pageId}
                  type="retain"
                  size={{ height: 50, width: 50 }}
                />
              );
            });
          });
          if (this.mounted) {
            return Promise.all(subAppPromises).then((subApps) => {
              this.setState({ subApps });
            });
          }
          return null;
        }
        return null;
      });
    });
  }

  loadChapters(setProgress) {
    const { lockedChapters, chapters_progress } = this.state;
    DataHandler.matchAppId().then((appId) =>
      APIHandler.getChapters(appId).then((res) => {
        if (!res || !Array.isArray(res.app)) {
          return;
        }
        const progressAt = (idx) =>
          chapters_progress[idx] || { percentage: undefined, last_page: 0 };
        const foundationChapters = res.app.filter(
          (chapter) => chapter.specialization === 0
        );
        const specializationChapters = res.app.filter(
          (chapter) => chapter.specialization === 1
        );

        const startingValues = [];
        Object.keys(res.app).map(() => {
          const newObj = {};
          newObj.data = 0;
          newObj.pos = 20;
          return startingValues.push(newObj);
        });
        if (!setProgress) {
          StorageHandler.load(storageKeys.user).then((user) => {
            if (!user || !user.response) return;
            APIHandler.registerUserProgress(user.response.email).then(
              (registered) => {
                if (registered) {
                  this.getProgress(); // This function rechecks user progress
                }
              }
            );
          });
        } else {
          const chapters = (
            <StaggeredMotion
              defaultStyles={startingValues}
              styles={(prevInterpolatedStyles) =>
                prevInterpolatedStyles.map((_, i) =>
                  i === 0
                    ? {
                        data: spring(1, { stiffness: 320, damping: 28 }),
                        pos: spring(0, { stiffness: 320, damping: 28 }),
                      }
                    : {
                        data: spring(prevInterpolatedStyles[i - 1].data, {
                          stiffness: 320,
                          damping: 28,
                        }),
                        pos: spring(prevInterpolatedStyles[i - 1].pos, {
                          stiffness: 320,
                          damping: 28,
                        }),
                      }
                )
              }
            >
              {(styles) => (
                <React.Fragment>
                  <React.Fragment>
                    <span className="subHeader">
                      <ContentHeader
                        header={i18n.translate('contentHeaders.maintrainings')}
                        subtitle={i18n.translate(
                          'pageDescriptions.maintrainings'
                        )}
                        line
                      />
                    </span>
                    {foundationChapters.map((chapter, key) => (
                      <div
                        key={key}
                        className={clsx('trainingCard__Animated', {})}
                        onClick={() => trackShare(key + 1)}
                      >
                        <TrainingCard
                          chapter={chapter}
                          chapterCount={chapter.chapterItemCount}
                          locked={
                            progressAt(key).percentage < 100 ||
                            progressAt(key).percentage === undefined
                          }
                          index={key}
                          appId={appId}
                          key={chapter.chapterID}
                          redirPath="/main/ret/chapter/"
                          foundation
                          comingSoon={chapter.coming_soon_visible}
                          lockedSubtitle={i18n.translate(
                            'trainingScreens.unlock',
                            { number: key + 1 }
                          )}
                        />
                      </div>
                    ))}
                    {specializationChapters.length > 0 && (
                      <span className="subHeader">
                        <ContentHeader
                          header={i18n.translate('contentHeaders.subtrainings')}
                          subtitle={i18n.translate(
                            'pageDescriptions.subtrainings'
                          )}
                          line
                        />
                      </span>
                    )}
                    {specializationChapters.map((chapter, key) => (
                      <div
                        key={key}
                        className={clsx('trainingCard__Animated', {
                          specialization: true,
                        })}
                        onClick={() => trackShare(key + 1)}
                      >
                        <TrainingCard
                          chapter={chapter}
                          chapterCount={chapter.chapterItemCount}
                          locked={
                            progressAt(key + foundationChapters.length)
                              .percentage < 100 ||
                            progressAt(key + foundationChapters.length)
                              .percentage === undefined
                          }
                          index={key}
                          appId={appId}
                          key={chapter.chapterID}
                          redirPath="/main/ret/chapter/"
                          foundation={false}
                          lockedSubtitle={i18n.translate(
                            'trainingScreens.unlock',
                            {
                              number: foundationChapters.length + 1,
                            }
                          )}
                          comingSoon={chapter.coming_soon_visible}
                        />
                      </div>
                    ))}
                  </React.Fragment>
                </React.Fragment>
              )}
            </StaggeredMotion>
          );
          this.setState({ chapters, lockedChapters });
        }
      })
    );
  }

  calculateProgress(res) {
    const progressOk =
      res &&
      res.status !== 'error' &&
      res.data &&
      res.data[0] &&
      Array.isArray(res.data[0].chapters);

    if (progressOk) {
      const { chapters } = res.data[0];
      chapters.forEach((chapter) => {
        const newChapter = chapter;
        if (chapter.progress > 0 && chapter.total_pages > 0) {
          newChapter.percentage = Math.floor(
            (chapter.progress / (chapter.total_pages - 1)) * 100
          );
          if (newChapter.percentage > 100) {
            newChapter.percentage = 100;
          }
          if (
            Math.floor((chapter.total_pages / chapter.last_page) * 100) === 100
          ) {
            newChapter.percentage = 100;
          }
        }
      });
      this.setState({ chapters_progress: chapters }, () => {
        this.loadChapters(true);
      });
    } else {
      this.loadChapters(false);
    }
  }

  render() {
    const { lockedChapters, subApps, chapters } = this.state;
    const allUnlocked = lockedChapters.every((isLocked) => isLocked === false);
    return (
      chapters && (
        <div className="wrapper__grid">
          <div className="trainingGrid">{chapters}</div>
          <p className="subtitle">
            {i18n.translate(
              `trainingScreens.${
                allUnlocked ? 'allUnlocked' : 'unlockSubtitle'
              }`
            )}
          </p>
          {subApps.length > 0 && (
            <ContentHeader
              header={i18n.translate('contentHeaders.subapps')}
              subtitle={i18n.translate('pageDescriptions.subapps')}
            />
          )}
          <div className="trainingGrid subApps">{subApps}</div>
        </div>
      )
    );
  }
}
